// removed by extract-text-webpack-plugin
module.exports = {"logged-out-controls":"logged-out-controls___J4olr","link-default":"link-default___3j3sO","button-default":"button-default___25diZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Login/LoggedOut.scss
// module id = +1eV
// module chunks = 60